import { FC } from "react";
import { AppPartType } from "../../../types";
import { Input } from "antd";

type Prop = {
  appPart: AppPartType;
};
const TextArea: FC<Prop> = ({
  appPart: { default_value, item_config_data },
}) => {
  const rowsNum = (() => {
    if (item_config_data?.h < 3) {
      return item_config_data?.h - 1;
    } else if (item_config_data?.h < 6) {
      return item_config_data?.h + 2;
    } else if (item_config_data?.h < 9) {
      return item_config_data?.h + 4;
    } else if (item_config_data?.h < 12) {
      return item_config_data?.h + 6;
    } else if (item_config_data?.h < 15) {
      return item_config_data?.h + 8;
    } else if (item_config_data?.h < 18) {
      return item_config_data?.h + 10;
    } else if (item_config_data?.h < 21) {
      return item_config_data?.h + 12;
    } else {
      return item_config_data?.h + 15;
    }
  })();

  return <Input.TextArea rows={rowsNum} value={default_value} />;
};

export default TextArea;
